export const createForRadioData = [
  { name: 'New Rebate Program', value: 'newRpc' },
  { name: 'Single Invoice', value: 'single' },
];

export const PLAN_TYPE_DATA = [
  { name: 'Medicaid', value: 'FD' },
  { name: 'Commercial', value: 'COMM' },
  { name: 'State', value: 'ST' },
  { name: 'Supplemental', value: 'SUPP' },
];
export const PLAN_TYPE_COMMERCIAL_DATA = [
  { name: 'Medicaid', value: 'FD' },
  { name: 'State', value: 'ST' },
  { name: 'Supplemental', value: 'SUPP' },
];

export const SELECT_TYPE_DATA = [
  { name: 'Cumulative', value: 'cumulative' },
  { name: 'Single Period', value: 'single' },
];
export const TRANSITION_TYPE_DATA = [
  { name: 'Claim Files', value: 'claim' },
  { name: 'Invoice Payment', value: 'invoice' },
];
